// The certificate page's lines (Certificate.dc.html; Adam, 3 Oct, for the certificate with no
// intake). Pure, so a test can import it.

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
  'October', 'November', 'December']

// A date column (YYYY-MM-DD) as "14 October 2026", or without its year, as the check page writes it
export function certificateDate(iso, withYear = true) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '')
  if (!m) return ''
  const day = `${Number(m[3])} ${MONTHS[Number(m[2]) - 1]}`
  return withYear ? `${day} ${m[1]}` : day
}

// "9 September to 14 October" (the eyebrow), or with the year on the end (the certificate's line)
export function periodLine(c, withYear) {
  if (!c?.period_from || !c?.period_to) return null
  const sameYear = c.period_from.slice(0, 4) === c.period_to.slice(0, 4)
  return `${certificateDate(c.period_from, !sameYear && withYear)} to ${certificateDate(c.period_to, withYear)}`
}

// The line under the name, word for word the PDF's (certificate-pdf/logic.ts completionLine): with an
// intake, its line and its dates ("from 9 September to 14 October 2026", or "starting 9 September
// 2026" while it has no end date); without one, "has completed The Funding Engine." (Adam, 3 Oct)
export function completedLine(c, intakeLine) {
  let line = `has completed ${c.course_name}`
  if (c.cohort_label) {
    const intake = (intakeLine || '').trim()
    const period = c.period_from && c.period_to ? `from ${periodLine(c, true)}`
      : c.period_from ? `starting ${certificateDate(c.period_from)}` : ''
    if (intake) line += `: ${intake}`
    if (period) line += `, ${period}`
  }
  return `${line}.`
}

// What the rule counts, in the product's own words: a live course has weeks, an on-demand course
// has modules of recordings
const watchedWhat = type => (type === 'live_cohort' ? 'week' : 'recording')

// The page's lede, from the product's rule
export function readyLine(rule, type = 'live_cohort') {
  const what = watchedWhat(type)
  if (rule === 'all_watched_and_homework') return `Every ${what} watched and every piece of homework ticked. Your certificate is ready.`
  if (rule === 'all_watched') return `Every ${what} watched. Your certificate is ready.`
  return 'Your certificate is ready.'
}

// Before the rule is met
export function notReadyLine(p) {
  if (!p.certificate_on) return `${p.name} doesn't have a certificate.`
  const what = watchedWhat(p.type)
  if (p.certificate_rule === 'all_watched_and_homework') return `It's ready as soon as every ${what} is watched and every piece of homework ticked, and it shows here.`
  if (p.certificate_rule === 'all_watched') return `It's ready as soon as every ${what} is watched, and it shows here.`
  return "It's ready as soon as Adam issues it, and it shows here."
}

// "Your recordings, worksheets and prompts stay in your library for as long as The Funding Engine
// runs, and at least 12 months from when your access began." (terms 2.2)
export function staysLine(p) {
  const from = p.min_access_from === 'purchase' ? 'from when you bought it' : 'from when your access began'
  const min = p.min_access_months ? `, and at least ${p.min_access_months} months ${from}` : ''
  return `Your recordings, worksheets and prompts stay in your library for as long as ${p.name} runs${min}. `
    + 'Your certificate stays in your account under My programmes, with the download and the check link.'
}

// LinkedIn's own page for adding a certification to a profile, filled in
export function linkedinUrl(c, issuer, checkUrl) {
  const [y, m] = String(c.completed_on || '').split('-')
  const q = new URLSearchParams({
    startTask: 'CERTIFICATION_NAME', name: c.course_name, organizationName: issuer,
    issueYear: y || '', issueMonth: String(Number(m) || ''), certUrl: checkUrl, certId: c.number,
  })
  return `https://www.linkedin.com/profile/add?${q.toString()}`
}

